export const ESTADOS_COLOR = {
  Activo   : "success",
  Inactivo : "error",
  Potencial: "warning",
  PreVenta : "info",
};